$(document).ready(function(){
    $('input[name="vous-etes"]').on('change',function(){
        if($(this).val() == "Un particulier" || $(this).val() == "An individual"){
            $('input[name="societe"]').prop('required',false);
            $('input[name="societe"]').attr('aria-required',false);
            $('label[for="societe"]').html($('label[for="societe"]').html().replace('*',''));
            $('.is_entreprise').hide();
        }else{
            if($(this).val() == "Une entreprise" || $(this).val() == "A company"){
                $('.is_entreprise').show();
            }else{
                $('.is_entreprise').hide();
            }
            $('input[name="societe"]').prop('required',true);
            $('input[name="societe"]').attr('aria-required',true);
            $('label[for="societe"]').html($('label[for="societe"]').html().replace('*','') + '*');
        }
    });
});